

































import Component, { mixins } from "vue-class-component";
import { Route } from "vue-router";
import { InputTransactionsSearch } from "@teacherskaya/api-provider/dist/api/TransactionProvider";
import { User } from "@teacherskaya/api-provider/dist/api/UserProvider";
import { parseTimeFrom, parseTimeTo } from "@/lib/helpers/time";
import { WatchRoute } from "@/lib/helpers/customDecorators";
import { $t } from "@/lib/helpers/i18nHelper";
import providers from "@/lib/providers";
import WithLoggedInUser from "@/mixins/WithLoggedInUser";
import WithUser from "@/mixins/WithUser";
import WithTransactions from "@/mixins/WithTransactions";
import WithFirstLoad from "@/mixins/WithFirstLoad";
import WithLoadingStatus from "@/mixins/WithLoadingStatus";
import GoBack from "@/components/GoBack.vue";
import ModalConfirm from "@/components/ModalConfirm.vue";
import PageTitle from "@/components/PageTitle.vue";
import BasePageOneColumn from "@/components/BasePageOneColumn.vue";
import QueryPagination from "@/components/QueryPagination.vue";
import WrapperCheckAuthorities from "@/components/WrapperCheckAuthorities.vue";
import TransactionsFilter from "./components/TransactionsFilter.vue";
import TransactionsTable from "./components/TransactionsTable.vue";

@WatchRoute("submitQuerySearch")
@Component({
  name: "PageTransactions",
  components: {
    WrapperCheckAuthorities,
    TransactionsTable,
    BasePageOneColumn,
    TransactionsFilter,
    PageTitle,
    GoBack,
    QueryPagination,
    ModalConfirm,
  },
})
export default class PageTransactions extends mixins(
  WithTransactions,
  WithLoggedInUser,
  WithUser,
  WithFirstLoad,
  WithLoadingStatus
) {
  public isLoading: boolean = true;

  public user: User | null = null;

  public transactionDataToDelete: { id: string; cd: () => void } | null = null;

  get transactions() {
    return (this.transactionsState && this.transactionsState.result) || [];
  }

  get totalPages() {
    return (this.transactionsState && this.transactionsState.totalPages) || 0;
  }

  get userId() {
    return (this.$route.query.userId || "").toString();
  }

  get userName() {
    if (this.userId !== null && !this.user) {
      this.userFindById(this.userId).then(r => (this.user = r));
    }
    return (this.user && this.user.screenName) || "";
  }

  get ruleKey() {
    return this.loggedInUser.id === this.userId ? "get_my" : "get_any";
  }

  get transactionDeleteConfirmText(): string {
    if (!this.transactionDataToDelete) return "";
    return $t("Are you sure want to {0} {1}?", [
      $t("delete the transaction"),
      $t(`ID: ${this.transactionDataToDelete.id || ""}`),
    ]);
  }

  public onChipInput() {
    this.$router.push({ query: { ...this.$route.query, userId: undefined } });
  }

  public getTransactions(data: InputTransactionsSearch = {}): Promise<any[]> {
    return this.loadingStatusShow([
      this.transactionsSearch({ data }).then(state => {
        this.transactionsState = state;
      }),
    ]);
  }

  public async deleteTransaction() {
    if (!this.transactionDataToDelete) {
      return;
    }

    try {
      const response = await providers.TransactionProvider.delete({ id: this.transactionDataToDelete.id });
      if (response) {
        await this.submitQuerySearch(this.$route);
      }
    } finally {
      this.clearDeletingData();
    }
  }

  public clearDeletingData() {
    if (!this.transactionDataToDelete) {
      return;
    }
    this.transactionDataToDelete.cd();
    this.transactionDataToDelete = null;
  }

  public submitQuerySearch(route: Route) {
    const query = route.query;
    const data: InputTransactionsSearch = {
      term: query.term ? query.term.toString() : undefined,
      page: query.page ? Number(query.page) : undefined,
      size: query.size ? Number(query.size) : undefined,
      sort: query.sort ? query.sort.toString() : "TIME,DESC",
      timeFrom: query.timeFrom ? parseTimeFrom(query.timeFrom.toString()) : undefined,
      timeTo: query.timeTo ? parseTimeTo(query.timeTo.toString()) : undefined,
      type: query.type ? query.type.toString() : undefined,
      userId: query.userId ? query.userId.toString() : undefined,
    };

    this.getTransactions(data).then(() => {
      this.setFirstLoad();
      this.isLoading = false;
    });
  }
}
